import type { TranslateDictionary } from './en.js';

export const Fr: TranslateDictionary = {
  'Start airplay': 'Démarrer AirPlay',
  'Stop airplay': 'Arrêter AirPlay',
  Audio: 'Audio',
  Captions: 'Sous-titres',
  'Enable captions': 'Activer les sous-titres',
  'Disable captions': 'Désactiver les sous-titres',
  'Start casting': 'Démarrer la diffusion',
  'Stop casting': 'Arrêter la diffusion',
  'Casting to {device}': 'Diffusion sur {device}',
  'Enter fullscreen mode': 'Passer en mode plein écran',
  'Exit fullscreen mode': 'Quitter le mode plein écran',
  Mute: 'Désactiver le son',
  Unmute: 'Activer le son',
  'Enter picture in picture mode': "Activer le mode image dans l'image",
  'Exit picture in picture mode': "Désactiver le mode image dans l'image",
  Play: 'Lire',
  Pause: 'Pause',
  'Playback rate': 'Vitesse de lecture',
  'Playback rate {playbackRate}': 'Vitesse de lecture {playbackRate}',
  Quality: 'Qualité',
  'Seek backward': 'Reculer',
  'Seek forward': 'Avancer',
  Settings: 'Paramètres',
  Auto: 'Auto',
  'audio player': 'lecteur audio',
  'video player': 'lecteur vidéo',
  volume: 'volume',
  seek: 'recherche',
  'closed captions': 'sous-titres',
  'current playback rate': 'vitesse de lecture actuelle',
  'playback time': 'temps de lecture',
  'media loading': 'chargement du média',
  settings: 'paramètres',
  'audio tracks': 'pistes audio',
  quality: 'qualité',
  play: 'lire',
  pause: 'pause',
  mute: 'désactiver le son',
  unmute: 'activer le son',
  'chapter: {chapterName}': 'chapitre: {chapterName}',
  live: 'live',
  preview: 'aperçu',
  Off: 'Désactivé',
  'start airplay': 'démarrer AirPlay',
  'stop airplay': 'arrêter AirPlay',
  'start casting': 'démarrer la diffusion',
  'stop casting': 'arrêter la diffusion',
  'enter fullscreen mode': 'passer en mode plein écran',
  'exit fullscreen mode': 'quitter le mode plein écran',
  'enter picture in picture mode': "activer le mode image dans l'image",
  'exit picture in picture mode': "désactiver le mode image dans l'image",
  'seek to live': 'revenir au direct',
  'playing live': 'en direct',
  'seek back {seekOffset} seconds': 'reculer de {seekOffset} secondes',
  'seek forward {seekOffset} seconds': 'avancer de {seekOffset} secondes',
  'Network Error': 'Erreur réseau',
  'Decode Error': 'Erreur de décodage',
  'Source Not Supported': 'Source non prise en charge',
  'Encryption Error': 'Erreur de chiffrement',
  'A network error caused the media download to fail.':
    'Une erreur réseau a empêché le téléchargement du média.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Une erreur média a interrompu la lecture. Le média est peut-être corrompu ou votre navigateur ne prend pas en charge ce format.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    "Une erreur non prise en charge s'est produite. Le serveur ou le réseau a rencontré un problème, ou votre navigateur ne prend pas en charge ce format.",
  'The media is encrypted and there are no keys to decrypt it.':
    "Le média est chiffré et il n'y a pas de clés pour le déchiffrer.",
  "This video cannot be played on your device because it doesn't meet the content protection requirements.":
    'Cette vidéo ne peut pas être lue sur votre appareil, car celui-ci ne répond pas aux exigences de protection du contenu.',
  'There was an error with the content protection system.':
    "Une erreur s'est produite avec le système de protection du contenu.",
  'This video requires a secure connection (HTTPS) to play DRM-protected content.':
    'Cette vidéo nécessite une connexion sécurisée (HTTPS) pour lire un contenu protégé par DRM.',
  'An error occurred during playback. The media could not be loaded.':
    "Une erreur s'est produite pendant la lecture. Le média n'a pas pu être chargé.",
  'There was an error during initialization of the DRM system.':
    "Une erreur s'est produite lors de l'initialisation du système DRM.",
  'The content license has expired.': 'La licence du contenu a expiré.',
};
